export default "__VITE_ASSET__CEK_iP7P__"